export const ADMIN_ENDPOINT = '/admin';

export const AdminCacheKeys = Object.freeze({
  GetAccountConnections: 'getAccountConnections',
  GetNotApprovedUsers: 'getNotApprovedUsers',
  GetCustomerReports: 'getCustomerReports',
  GetUsers: 'getUsers',
  GetCustomersWithPages: 'getCustomersWithPages',
  GetDatastreams: 'getDatastreams',
  GetCustomersWithSideUsers: 'getCustomersWithSideUsers',
});
